import { useState } from 'react'
import { Form, Button, InputGroup } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { UpdateSiteParameter } from '../../../Services/ParameterService'

const SiteParamRow = ({ param, dbRow, siteId, api, onSaved }) => {
    const initial = dbRow ? (dbRow[param.valueKey] ?? '') : ''
    const [value, setValue] = useState(initial)
    const [savedValue, setSavedValue] = useState(initial)
    const [isSaving, setIsSaving] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const isDirty = value !== savedValue

    const handleSave = () => {
        setIsSaving(true)
        UpdateSiteParameter(api, param.id, siteId, param.valueKey, value)
            .then(() => {
                setSavedValue(value)
                onSaved?.(siteId, param.id, param.valueKey, value)
                toast.success(`Zapisano parametr`)
            })
            .catch(() => toast.error(`Błąd zapisu parametru!`))
            .finally(() => setIsSaving(false))
    }

    const renderInput = () => {
        if (param.type === 'boolean') {
            return (
                <Form.Check
                    type='switch'
                    id={`site-param-${siteId}-${param.id}`}
                    checked={value === true || value === 'true'}
                    onChange={e => setValue(e.target.checked)}
                    className='mt-1'
                />
            )
        }

        if (param.type === 'textarea') {
            return (
                <Form.Control
                    as='textarea'
                    rows={3}
                    value={value ?? ''}
                    onChange={e => setValue(e.target.value)}
                    size='sm'
                />
            )
        }

        if (param.type === 'password') {
            return (
                <InputGroup size='sm'>
                    <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        value={value ?? ''}
                        onChange={e => setValue(e.target.value)}
                    />
                    <Button
                        variant='outline-primary'
                        onClick={() => setShowPassword(p => !p)}
                        tabIndex={-1}
                    >
                        {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                    </Button>
                </InputGroup>
            )
        }

        return (
            <Form.Control
                type={param.type}
                value={value ?? ''}
                onChange={e => setValue(e.target.value)}
                size='sm'
            />
        )
    }

    return (
        <tr>
            <td className='text-muted small align-middle' style={{ width: '35%' }}>
                {dbRow?.paramDesc ?? param.id}
                <div className='text-secondary' style={{ fontSize: '0.7rem' }}>{param.id}</div>
            </td>
            <td className='align-middle' style={{ width: '55%' }}>
                {renderInput()}
            </td>
            <td className='align-middle text-end' style={{ width: '10%' }}>
                {param.type !== 'boolean' && (
                    <Button
                        size='sm'
                        variant={isDirty ? 'primary' : 'outline-secondary'}
                        disabled={!isDirty || isSaving}
                        onClick={handleSave}
                    >
                        {isSaving ? '...' : 'Zapisz'}
                    </Button>
                )}
                {param.type === 'boolean' && isDirty && (
                    <Button
                        size='sm'
                        variant='primary'
                        disabled={isSaving}
                        onClick={handleSave}
                    >
                        {isSaving ? '...' : 'Zapisz'}
                    </Button>
                )}
            </td>
        </tr>
    )
}

export default SiteParamRow
